import React from 'react';
import * as Styled from './NavFlyout.styled';
import NavigationSection from './NavSection';

/**
 * Determines the number of columns based on the length of the navigation array.
 *
 * @param {Array} navArray - The array containing navigation items.
 * @returns {number} The number of columns to be used.
 */
function getNumColumns(navArray) {
  const navCount = navArray.length;
  switch (navCount) {
    case 4:
      return 1;
    case 3:
    case 2:
      return 2;
    case 1:
      return 3
    case 0:
      return 4;
    default:
      return 4;
  }
}

/**
 * Transforms sections and cards into an array of column objects.
 *
 * @param {Array} sections - An array of section objects to be transformed.
 * @param {Array} cards - An array of card objects to be transformed.
 * @returns {Array} An array of column objects, each containing a type and content.
 */
export function transformArrays(sections, cards) {
  const NAVIGATION = 'navigation';
  const CARD_CONTAINER = 'cardContainer';

  const columns = [];

  sections.forEach((section) => {
    columns.push({ type: NAVIGATION, content: section });
  });

  if (cards.length > 0) {
    columns.push({ type: CARD_CONTAINER, content: cards });
  }

  return columns;
}

export const generateColumns = ({ sections, menuTileGroup }) => {
  const columns = transformArrays(sections, menuTileGroup?.tiles);
  const numColumns = getNumColumns(sections);

  return columns.map((column, colIndex) => (
    <React.Fragment key={`col-${colIndex}`}>
      {column.type === 'navigation' && (
        <Styled.NavFlyoutColumn>
          <NavigationSection item={column} />
        </Styled.NavFlyoutColumn>
      )}
      {column.type === 'cardContainer' && (
        <Styled.CardContainer numColumns={numColumns}>
          {column.content.map((card, index) => (
            <Styled.ContentCard
              key={`card-${index}`}
              backgroundColor="transparent"
              header={card.text}
              alignment="left"
              ctas={[{ url: card.url }]}
              width={card.image.file.details.image.width}
              height={card.image.file.details.image.height}
              src={card.image.file.url}
              titleFontSize={14}
            />
          ))}
        </Styled.CardContainer>
      )}
    </React.Fragment>
  ));
};

export default {};
